import { render, staticRenderFns } from "./RushRacePlayer.vue?vue&type=template&id=54fa33b0&scoped=true&"
import script from "./RushRacePlayer.vue?vue&type=script&lang=js&"
export * from "./RushRacePlayer.vue?vue&type=script&lang=js&"
import style0 from "./RushRacePlayer.vue?vue&type=style&index=0&id=54fa33b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa33b0",
  null
  
)

export default component.exports